import { FlexBox } from "@brg/ui";
import { FC } from "react";

export const HoverContainer: FC<{ 
    children: any, 
    onMouseLeave: (ev: any) => void,
    onMouseEnter?: (ev: any) => void, 
    hoverRef?: any 
}> = ({ 
    children, 
    onMouseLeave,
    onMouseEnter, 
    hoverRef 
}) => {
    return (
        <FlexBox 
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave} 
            ref={hoverRef}
        >
            {children}
        </FlexBox>
    )
}import { FlexBox } from "@brg/ui";
import { FC } from "react";

export const HoverContainer: FC<{ 
    children: any, 
    onMouseLeave: (ev: any) => void,
    onMouseEnter?: (ev: any) => void, 
    hoverRef?: any 
}> = ({ 
    children, 
    onMouseLeave,
    onMouseEnter, 
    hoverRef 
}) => {
    return (
        <FlexBox 
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave} 
            ref={hoverRef}
        >
            {children}
        </FlexBox>
    )
}